const AustriaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110810)">
      <path
        d="M38.756 26.9568C39.56 24.7902 40 22.4467 40 20.0003C40 17.5539 39.56 15.2105 38.756 13.0438L20 11.3047L1.24398 13.0438C0.440078 15.2105 0 17.5539 0 20.0003C0 22.4467 0.440078 24.7902 1.24398 26.9568L20 28.6959L38.756 26.9568Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9997 40.0005C28.599 40.0005 35.9299 34.573 38.7557 26.957H1.24365C4.06959 34.573 11.4004 40.0005 19.9997 40.0005Z"
        fill="#D80027"
      />
      <path
        d="M19.9997 0C11.4004 0 4.06959 5.4275 1.24365 13.0435H38.7558C35.9299 5.4275 28.599 0 19.9997 0Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110810">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default AustriaSvg;
